import axios from "axios";

const { REACT_APP_BACKEND_API_URL } = process.env;

export const apiAvaGetPrompts = async (userAuthToken: string, payload: any) => {
  try {
    const url = `${REACT_APP_BACKEND_API_URL}/ava-prompts/get-prompts`;
    const response = await axios.post(url, payload, { headers: { Authorization: `Bearer ${userAuthToken}` } });
    return response?.data;
  } catch (e: any) {
    throw e?.response?.data ? e?.response?.data : e;
  }
};
